import { BaseResponse, TableList } from '@/types/common';
import axiosInstance from './axiosInstance';
import {
  OrderDetail,
  OrderListParams,
  OrderListResponse,
  RechargeOrderListParams,
  AppleSubscribeQueryParams,
  AppleSubscribeRecord,
  GoogleSubscribeQueryParams,
  GoogleSubscribeRecord,
} from '@/types/order';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

// 获取订单列表
export const getOrderList = async (params: OrderListParams) => {
  const res = await axiosInstance.post<TableList<OrderListResponse>>(
    `${baseUrl}/order/list`,
    params
  );
  return res.data;
};

// 获取订单详情
export const getOrderDetail = async (orderId: string) => {
  const res = await axiosInstance.get<BaseResponse<OrderDetail>>(
    `${baseUrl}/order/detail/${orderId}`
  );
  return res.data;
};

// 退还积分
export const restoreOrderPoints = async (orderId: string) => {
  const res = await axiosInstance.post<BaseResponse<boolean>>(
    `${baseUrl}/order/restore`,
    { orderId }
  );
  return res.data;
};

// 订单号填写
export const getOrderUpdate = async (params: {
  orderId: string,
  trackingNum: string,
  logisticsCompany: string
}) => {
  const res = await axiosInstance.post<BaseResponse<OrderDetail>>(
    `${baseUrl}/order/update`,
    params
  );
  return res.data;
};

// 获取充值订单列表
export const getRechargeAppleList = async (params: RechargeOrderListParams) => {
  const res = await axiosInstance.post<TableList<OrderListResponse>>(
    `${baseUrl}/api/assert/v1/order/apple/query?currentPage=${params.currentPage}&pageSize=${params.pageSize}`,
    params
  );
  return res.data;
};

export const getRechargeGoogleList = async (params: OrderListParams) => {
  const res = await axiosInstance.post<TableList<OrderListResponse>>(
    `${baseUrl}/api/assert/v1/order/google/query?currentPage=${params.currentPage}&pageSize=${params.pageSize}`,
    params
  );
  return res.data;
};

/**
 * 苹果会员订阅查询
 * 响应格式: BaseResponse<TableList<AppleSubscribeRecord>>
 */
export const getAppleSubscribeQuery = async (params: AppleSubscribeQueryParams) => {
  const res = await axiosInstance.post<BaseResponse<TableList<AppleSubscribeRecord>>>(
    `${baseUrl}/api/apple/subscribe/query`,
    params
  );
  return res.data;
};

/**
 * 安卓会员订阅查询
 * 响应格式: BaseResponse<TableList<GoogleSubscribeRecord>>
 */
export const getGoogleSubscribeQuery = async (params: GoogleSubscribeQueryParams) => {
  const res = await axiosInstance.post<BaseResponse<TableList<GoogleSubscribeRecord>>>(
    `${baseUrl}/api/google/subscribe/query`,
    params
  );
  return res.data;
};

/**
 * 赠送会员
 * @param params 赠送会员参数
 */
export const giveVip = async (params: {
  level: number; // 会员等级
  days: number; // 赠送时长（天）
  userId: string; // 接受赠送人
  deviceType: number; // 设备类型: 0=iOS, 1=Android
}) => {
  const res = await axiosInstance.post<BaseResponse<boolean>>(
    `${baseUrl}/api/apple/givesVip`,
    params
  );
  return res.data;
};